import { IS_PROD_BUILD } from '@src/config/env'

export const isProd = IS_PROD_BUILD
